import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

import './VerticalMenuItem.css'

interface VerticalMenuItemProps {
	icon: IconProp
	label?: string
	onClick?: () => void
}

function VertivalMenuItem(props: VerticalMenuItemProps) {
	return (
		<div className='verticalMenuItem' onClick={props.onClick}>
			<FontAwesomeIcon icon={props.icon} size='2x' />
			<label className='verticalMenuItemLabel'>{props.label}</label>
		</div>
	)
}

export default VertivalMenuItem
